module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Russell Duly struggled in his early school years with reading and writing because of what he now believes was undiagnosed dyslexia, which prevented him from earning any English qualifications. Despite this, Russell continued with his education, perhaps to prove that he wasn’t as unintelligent as he first thought. He said to himself, ‘There is “drive and ambition in everyone”, we just need to direct it properly.’ So, Russell set about studying for a professional qualification in surveying, which he successfully achieved many years later. The thought of writing a children’s novel came to fruition during his work as a surveyor, which involved many seemingly wasted hours on a train travelling to London. Russell wanted to channel his ever-bursting imagination and creativity into a wonderful story, and by reading it he hopes to inspire other people to overcome their challenges and do the same.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0